import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import HelmetInfo from "Components/HelmetInfo/HelmetInfo";
import ModalRequestAndAddProject from "Components/ModalRequestAndAddProject/ModalRequestAndAddProject";
import { toast } from "react-toastify";
import { collection, doc, getDocs, deleteDoc } from "firebase/firestore";
import { db } from "../../firebase";
import WorkHeaderInfo from "Pages/WorkInformation/WorkHeaderInfo/WorkHeaderInfo";
import { AgGridReact } from "ag-grid-react";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const Subsicribed = () => {
  const { t } = useTranslation();
  const [cards, setCards] = useState([]);
  const [showModal, setShowModalSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const router = useNavigate();

  const handleDeleteCard = async (cardId) => {
    try {
      const docRef = doc(db, "Subsicribed", cardId);
      await deleteDoc(docRef);
      setCards(cards.filter((card) => card.id !== cardId));
      toast.success(t("CardDeletedSuccessfully"), {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } catch (error) {
      console.error("Error deleting card:", error);
      toast.error(t("CardDeletionFailed"), {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  };

  const columnDefs = [
    {
      headerName: t("email"),
      field: "email",
      flex: 2,
    },
    {
      headerName: t("Date"),
      field: "Date",
      flex: 1,
      sort: "desc"
    },
    {
      headerName: t("Actions"),
      field: "id",
      flex: 1,
      cellRenderer: (params) => (
        <button onClick={() => handleDeleteCard(params.value)} className="btn btn-danger">
          <FontAwesomeIcon icon={faTrash} />
        </button>
      )
    }
  ];

  const fetchCards = async () => {
    try {
      const collectionRef = collection(db, "Subsicribed");
      const snapshot = await getDocs(collectionRef);
      const cardsData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      })).sort((a, b) => new Date(b.Date) - new Date(a.Date));
      
      console.log("cardsData", cardsData);
      setCards(cardsData);
    } catch (error) {
      console.error("Error fetching cards:", error);
    }
  };

  useEffect(() => {
    fetchCards();
  }, []);

  const handleCloseModal = () => {
    setShowModalSuccess(false);
    router("/home");
  };

  const handleOpenModalSuccess = () => {
    setShowModalSuccess(true);
  };
  
  return (
    <>
      <HelmetInfo titlePage={t("Subsicribed")} />
      <ModalRequestAndAddProject
        showModal={showModal}
        handleCloseModal={handleCloseModal}
      />
      <div className="project-management-request all-main">
        <WorkHeaderInfo title={t("Subsicribed")} />
        <div className="d-flex justify-content-end"></div>
        <div className="form-project-management">
          <div className="row Servcis-Cards">
            {cards.length > 0 ? (
              <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
                <AgGridReact
                  paginationPageSize={10}
                  columnDefs={columnDefs}
                  rowData={cards}
                  defaultColDef={{ sortable: true }}
                />
              </div>
            ) : (
              <p>{t("NoSubsicribed")}</p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Subsicribed;